import { type RouteLocationNormalized } from 'vue-router';

export const PERFORMANCE_DASHBOARD_ROUTE_NAME = 'performance-dashboard';

interface ShouldStripQueryOptions {
  hasJobsQueryParams: boolean;
  isValidCopilotActivationRoute: boolean;
}

export function shouldStripQuery(
  to: Pick<RouteLocationNormalized, 'path' | 'name' | 'query'>,
  from: Pick<RouteLocationNormalized, 'path'>,
  { hasJobsQueryParams, isValidCopilotActivationRoute }: ShouldStripQueryOptions,
): boolean {
  // The dashboard syncs its tab and filters into the query string, so never strip it.
  const isPerformanceDashboardRoute = to.name === PERFORMANCE_DASHBOARD_ROUTE_NAME;

  return (
    to.path !== from.path &&
    Object.keys(to.query).length > 0 &&
    !hasJobsQueryParams &&
    !isValidCopilotActivationRoute &&
    !isPerformanceDashboardRoute
  );
}
